import axios from "axios";

function errorHandler(error, reject) {
  console.log(error);
  if (error.response && error.response.data) {
    reject(error.response.data);
  } else {
    reject(error);
  }
}

export default {
  edit(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["departkd", "tahun"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/budgetdept/edit${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  copywithmarkup(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        // const keys = ['tahun'];
        // let str = '';
        // for (const key in obj) {
        //     if (keys.indexOf(key) >= 0 && obj[key]) {
        //         str += str ? '&' : '?';
        //         str += key + '=' + encodeURIComponent(obj[key]);
        //     }
        // }
        const url = `/budgetdept/copywithmarkup/${obj.tahun}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  save(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        await axios.post("budgetdept", obj);
        resolve();
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  savecopywithmarkup(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const hasil = await axios.post("/budgetdept/copywithmarkup", obj);
        resolve(hasil);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  createBudget(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        await axios.post("budgetdept/create", obj);
        resolve();
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  view(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["departkd", "tahun", "layout"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/budgetdept/view${str}`;
        const { data } = await axios.get(url);
        resolve(data[0]);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  viewprint(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["departkd", "departemen", "tahun", "layout"];

        let str = "?";
        // if (obj.tabIndex === 0) {
        //     str += 'view=' + encodeURIComponent('summary');
        // } else {
        //     str += 'view=' + encodeURIComponent('current');
        // }
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        const url = `/budgetdept/viewprint${str}`;
        const { data } = await axios.get(url);
        console.log("data : ", data);
        const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`;
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  viewexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["departkd", "departemen", "tahun", "layout"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        let response = await axios({
          url: `/budgetdept/viewexport${str}`,
          method: "GET",
          responseType: "blob", // important
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `annual_budget_${obj.departkd}_${obj.tahun}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        resolve(link);
      } catch (error) {
        let responseObj = await error.response.data.text();
        errorHandler(JSON.parse(responseObj), reject);
      }
    });
  },
  actual(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["departkd", "tahun", "tgl1", "tgl2", "layout"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/budgetdept/actual${str}`;
        const { data } = await axios.get(url);
        resolve(data[0]);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  actualexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "departkd",
          "departemen",
          "tahun",
          "tgl1",
          "tgl2",
          "layout",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        let response = await axios({
          url: `/budgetdept/actualexport${str}`,
          method: "GET",
          responseType: "blob", // important
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `annual_budget_actual_${obj.tahun}.xlsx`);
        document.body.appendChild(link);
        link.click();
        resolve(link);
      } catch (error) {
        let responseObj = await error.response.data.text();
        errorHandler(JSON.parse(responseObj), reject);
      }
    });
  },
  actualv2(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "opsiDept",
          "departkd",
          "departemen",
          "DimCol",
          "tahun",
          "tgl1",
          "tgl2",
          "layout",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/budgetdept/actualv2${str}`;
        const { data } = await axios.get(url);
        resolve(data[0]);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  actualv2export(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "opsiDept",
          "departkd",
          "departemen",
          "DimCol",
          "tahun",
          "tgl1",
          "tgl2",
          "layout",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        let response = await axios({
          url: `/budgetdept/actualv2export${str}`,
          method: "GET",
          responseType: "blob", // important
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `annual_budget_actual_${obj.tahun}.xlsx`);
        document.body.appendChild(link);
        link.click();
        resolve(link);
      } catch (error) {
        let responseObj = await error.response.data.text();
        errorHandler(JSON.parse(responseObj), reject);
      }
    });
  },
  actualv2ytdexport(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "departkd",
          "departemen",
          "DimCol",
          "tahun",
          "tgl1",
          "tgl2",
          "layout",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        let response = await axios({
          url: `/budgetdept/actualv2ytdexport${str}`,
          method: "GET",
          responseType: "blob", // important
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `annual_budget_actual_ytd_${obj.tahun}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        resolve(link);
      } catch (error) {
        let responseObj = await error.response.data.text();
        errorHandler(JSON.parse(responseObj), reject);
      }
    });
  },
  actualytdexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "departkd",
          "departemen",
          "tahun",
          "tgl1",
          "tgl2",
          "layout",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        let response = await axios({
          url: `/budgetdept/actualytdexport${str}`,
          method: "GET",
          responseType: "blob", // important
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `annual_budget_actual_${obj.tahun}.xlsx`);
        document.body.appendChild(link);
        link.click();
        resolve(link);
      } catch (error) {
        let responseObj = await error.response.data.text();
        errorHandler(JSON.parse(responseObj), reject);
      }
    });
  },

  layout(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        // const { data } = await axios.get(`budgetdept/layout/${encodeURIComponent(obj.layout)}`);
        const { data } = await axios.get(`budgetdeptfmt/${encodeURIComponent(obj.layout)}`);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  layout_combo() {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get(`budgetdeptfmt/combo`);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  layoutDel(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.delete(`budgetdeptfmt/${encodeURIComponent(obj.layout)}`);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  layoutSave(data) {
    return new Promise(async (resolve, reject) => {
      try {
        await axios.post("budgetdeptfmt", data);
        resolve();
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  ledger(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["kodeaw", "kodeak", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/budgetdept/ledger${str}`;
        const { data } = await axios.get(url);
        // console.log('data.tb : ', data[1]);
        resolve(data[0]);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  ledgerexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["kodeaw", "kodeak", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        let response = await axios({
          url: `/budgetdept/ledgerexport${str}`,
          method: "GET",
          responseType: "blob", // important
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `BudgetRealization_ledger_${obj.tgl2}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        resolve(link);
      } catch (error) {
        let responseObj = await error.response.data.text();
        errorHandler(JSON.parse(responseObj), reject);
      }
    });
  },
  fpbudget(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["layout", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/budgetdept/fpbudget${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  fpbudgetexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["layout", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        const response = await axios({
          url: `/budgetdept/fpbudgetexport${str}`,
          method: "GET",
          responseType: "blob", // important
        });
        resolve(response);
      } catch (error) {
        let responseObj = await error.response.data.text();
        errorHandler(JSON.parse(responseObj), reject);
      }
    });
  },
  fpbudgetprint(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["layout", "tgl1", "tgl2"];

        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        const url = `/budgetdept/fpbudgetprint${str}`;
        const { data } = await axios.get(url);
        const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`;
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  fpbudgetlayout(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        // const { data } = await axios.get(`budgetdept/layout/${encodeURIComponent(obj.layout)}`);
        const { data } = await axios.get(
          `budgetdept/fpbudgetlayout/${encodeURIComponent(
            obj.layout
          )}/${encodeURIComponent(obj.tahun)}`
        );
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
};
